import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { toast } from "sonner";
import ErrorBoundary from "@/components/ErrorBoundary";
import * as serviceWorkerRegistration from "@/serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);

serviceWorkerRegistration.register({
  onNewVersion: () =>
    toast("Nova versão do sistema disponível", {
      description: "Atualize para usar as últimas melhorias.",
      duration: Infinity,
      action: { label: "Atualizar agora", onClick: () => window.location.reload() },
    }),
});
